import React, { useState } from "react";
import { Box, Typography, Divider, Tabs, Tab } from "@mui/material";
import { useTranslationContext } from "../../../../hooks/translations/translationsProvider";
import RolesList from "./RolesList";
import UsersList from "./UsersList";
import UserRolesDetail from "./UserRolesDetail";
import { UserWithRoles } from "../../../../models/identity/IdentityManagement";
import { titleSx, tabsSx } from "./identityStyles";

type TabValue = "roles" | "users";

const IdentityManagement: React.FC = () => {
	const { t } = useTranslationContext();
	const [tab, setTab] = useState<TabValue>("roles");
	const [selectedUser, setSelectedUser] = useState<UserWithRoles | null>(null);

	// Cambiando tab si torna sempre alla lista, cosi' la tabulazione resta
	// sempre visibile e non si resta "bloccati" sul dettaglio di un utente.
	const handleTabChange = (_: React.SyntheticEvent, value: TabValue) => {
		setSelectedUser(null);
		setTab(value);
	};

	return (
		<Box>
			<Typography variant="h5" sx={{ mb: 2, ...titleSx }}>
				{t("Gestione Identity")}
			</Typography>

			<Tabs value={tab} onChange={handleTabChange} sx={{ mb: 2, ...tabsSx }}>
				<Tab label={t("Ruoli")} value="roles" />
				<Tab label={t("Utenti")} value="users" />
			</Tabs>
			<Divider sx={{ mb: 2 }} />

			{tab === "roles" && <RolesList />}

			{tab === "users" &&
				(selectedUser ? (
					<UserRolesDetail user={selectedUser} onBack={() => setSelectedUser(null)} />
				) : (
					<UsersList onSelectUser={setSelectedUser} />
				))}
		</Box>
	);
};

export default IdentityManagement;
